/**
 * Language-related constants for the TOFE application
 *
 * NOTE: This file re-exports constants from language-config.ts which loads
 * from language-config.json - the single source of truth for all languages.
 *
 * Use this file for backward compatibility. For new code, consider importing
 * directly from './language-config' for better type safety and additional utilities.
 */

import {
  ALL_LANGUAGES_LIST,
  DEFAULT_LANGUAGE as DEFAULT_LANG,
  DEFAULT_LOCALE as DEFAULT_LOC,
  LANGUAGE_TO_LOCALE_MAP as LOCALE_MAP,
} from './language-config';

/**
 * List of all supported language codes
 * @deprecated Use ALL_LANGUAGES_LIST from './language-config' instead
 */
export const AllLanguagesList = ALL_LANGUAGES_LIST;

/**
 * Mapping from language codes to their corresponding locale identifiers
 * Uses the primary locale for each language (e.g., 'en' -> 'en-US', 'it' -> 'it-IT')
 */
export const LANGUAGE_TO_LOCALE_MAP: Record<string, string> = LOCALE_MAP;

/**
 * Default language code
 */
export const DEFAULT_LANGUAGE = DEFAULT_LANG;

/**
 * Default locale
 */
export const DEFAULT_LOCALE = DEFAULT_LOC;
